import { toTitleCase } from './toTitleCase';

export const formatColorString = colorName => {
  if (!colorName) return colorName;

  let color = colorName.toLowerCase();
  ['/', '-', ' '].forEach(char => {
    color = color
      .split(char)
      .map(str => toTitleCase(str, false))
      .join(char);
  });
  return color;
};
